import React, { useState } from "react";
import { useI18n } from "../i18n";

const HERO = "https://customer-assets.emergentagent.com/job_store-hub-157/artifacts/jxy1s74o_IMG_4462.png";

export function AgeGate({ onAccept }) {
  const [shown] = useState(() => localStorage.getItem("stuff_age_ok") !== "1");
  if (!shown) return null;
  return <AgeGateOverlay onAccept={onAccept} />;
}

function AgeGateOverlay({ onAccept }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(true);
  if (!open) return null;

  const accept = () => {
    localStorage.setItem("stuff_age_ok", "1");
    setOpen(false);
    onAccept && onAccept();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="age-gate">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${HERO})` }} />
      <div className="absolute inset-0 bg-black/85 backdrop-blur-md" />
      <div className="relative z-10 max-w-md w-full bg-[#0c0c0f] border border-neon-magenta shadow-[0_0_35px_rgba(192,38,211,0.35)] p-10 text-center">
        <img src="/lion-head.webp" alt="Mascotte STUFF" className="mx-auto h-24 w-24 rounded-full object-cover border-2 border-neon-green shadow-[0_0_18px_rgba(157,255,0,0.4)] mb-5" />
        <div className="font-anton text-7xl neon-text-magenta mb-2">18+</div>
        <h2 className="font-anton text-2xl text-white uppercase mb-3">{t("age.title")}</h2>
        <p className="text-zinc-400 text-sm mb-2">
          {t("age.p1")} <span className="text-neon-green font-semibold">{t("age.p1b")}</span>.
        </p>
        <p className="text-zinc-400 text-sm mb-6">
          {t("age.p2a")} <span className="text-white font-semibold">{t("age.p2b")}</span> {t("age.p2c")}
        </p>
        <button
          data-testid="age-gate-accept"
          onClick={accept}
          className="w-full bg-neon-green text-black font-anton uppercase tracking-wide px-6 py-4 glow-green hover:bg-neon-greenDark transition-colors mb-3"
        >
          {t("age.enter")}
        </button>
        <a
          data-testid="age-gate-decline"
          href="https://www.google.com"
          className="block text-zinc-500 text-sm hover:text-zinc-300 transition-colors"
        >
          {t("age.leave")}
        </a>
      </div>
    </div>
  );
}
